import * as services from '@/services/personalCenter/aduitManagement'
import {
  getSurveyDetail
} from '@/services/preWarning/preWarningList'
import {
  getSubscribeDetail
} from '@/services/dataAnalysis/dataSubscription'
import { Message, MessageBox } from '@gcommon/gcommon-ui'
import i18n from '@/locales'
const state = {
  pageStatus: "toApplied",
  aduitDetailData: {
    id: "",
    audit: "同意",
    auditAdvice: "",
    detail: {}
  },
  aduitDetailVisible: false,
  aduitDetailType: '',
  selectData: {},

  //待审核的
  toAppliedSearchStr: '',
  toAppliedLoading: false,
  toAppliedDataList: [],
  toAppliedPagination: {},
  toAppliedParams: { pageNum: 1, pageSize: 10, orderColumn: 'updateTime', order: 'ASC' },
  //我申请的
  toPreviewSearchStr: '',
  toPreviewLoading: false,
  toPreviewDataList: [],
  toPreviewPagination: {},
  toPreviewParams: { pageNum: 1, pageSize: 10, orderColumn: 'updateTime', order: 'ASC' },
  //我审核的
  toReviewSearchStr: '',
  toReviewLoading: false,
  toReviewDataList: [],
  toReviewPagination: {},
  toReviewParams: { pageNum: 1, pageSize: 10, orderColumn: 'updateTime', order: 'ASC' }
}

const mutations = {
  commonMutations: (state, payload) => {
    Object.keys(payload).forEach(item => {
      state[item] = payload[item]
    })
  },
  initState: (state, payload) => {
    state.pageStatus = "toApplied",
      state.aduitDetailData = {
        id: "",
        audit: "同意",
        auditAdvice: "",
        detail: {}
      },
      state.aduitDetailVisible = false,
      state.aduitDetailType = '',
      state.selectData = {}

    state.toAppliedSearchStr = '',
      state.toAppliedLoading = false,
      // state.toAppliedDataList=[],
      // state.toAppliedPagination={pageNum:1,pageSize:10}
      state.toAppliedParams = { pageNum: 1, pageSize: 10, orderColumn: 'createTime', order: 'DESC' }

    state.toPreviewSearchStr = '',
      state.toPreviewLoading = false,
      // state.toPreviewDataList=[],
      // state.toPreviewPagination={pageNum:1,pageSize:10},
      state.toPreviewParams = { pageNum: 1, pageSize: 10, orderColumn: 'createTime', order: 'DESC' },

      state.toReviewSearchStr = '',
      state.toReviewLoading = false,
      // state.toReviewDataList=[],
      // state.toReviewPagination={pageNum:1,pageSize:10},
      state.toReviewParams = { pageNum: 1, pageSize: 10, orderColumn: 'createTime', order: 'DESC' }
  },
  lscommit: (state, payload) => {
    state.aduitDetailData = { ...state.aduitDetailData, auditorNodes: payload }
  }
}

const actions = {
  toAppliedListHandleSearch({ state, commit }, payload = state.toAppliedParams) {
    commit('commonMutations', { toAppliedLoading: true })
    services.getTableDataToApplied(payload).then(res => {
      if (res?.code === 200) {
        if (res.data.page) {
          res.data.page.total = res?.data?.page?.totalCount
        } else {
          res.data.page = { total: 0 }
        }
        commit('commonMutations', { toAppliedDataList: res?.data?.data, toAppliedPagination: res?.data.page })
      }
    })
    commit('commonMutations', { toAppliedLoading: false })
    commit('commonMutations', { toAppliedParams: payload })
  },

  toPreviewListHandleSearch({ state, commit }, payload = state.toPreviewParams) {
    commit('commonMutations', { toPreviewLoading: true })
    services.getTableDataToPreview(payload).then(res => {
      if (res?.code === 200) {
        if (res.data.page) {
          res.data.page.total = res?.data?.page?.totalCount
        } else {
          res.data.page = { total: 0 }
        }
        commit('commonMutations', { toPreviewDataList: res?.data?.data, toPreviewPagination: res?.data.page })
      }
    })
    commit('commonMutations', { toPreviewLoading: false })
    commit('commonMutations', { toPreviewParams: payload })
  },

  toPreviewHandleCancel({ state, commit, dispatch }, payload) {
    let lsParams = {
      auditId: payload.id,
      sourceType: payload.auditType,
      sourceId: payload.sourceIds
    }
    services.auditRecall(lsParams).then(res => {
      if (res?.code === 200) {
        Message({
          type: 'success',
          message: `${res?.msg}`
        })
        dispatch('toPreviewListHandleSearch')
      } else {
        // Message({
        //   type: 'error',
        //   message:`${res?.msg}`
        // })
      }
    })
  },

  toReviewListHandleSearch({ state, commit }, payload = state.toReviewParams) {
    commit('commonMutations', { toReviewLoading: true })
    services.getTableDataToReview(payload).then(res => {
      if (res?.code === 200) {
        if (res.data.page) {
          res.data.page.total = res?.data?.page?.totalCount
        } else {
          res.data.page = { total: 0 }
        }
        commit('commonMutations', { toReviewDataList: res?.data?.data, toReviewPagination: res?.data.page })
      }
    })
    commit('commonMutations', { toReviewLoading: false })
    commit('commonMutations', { toReviewParams: payload })
  },

  getAduitDetail({ state, commit }, payload) {
    let auditorNodes: any = []
    services.getAuditDetail({ sourceType: payload.auditType, id: payload.id }).then((res) => {
      auditorNodes.push(...res.data.auditorNodes)
      auditorNodes.unshift({
        auditorName: res.data.applicant,
        auditorCode: res.data.applicantCode,
        advice: res.data.remark,
        auditTime: res.data.applicantTime,
      })
      const tabName = state.pageStatus === 'toApplied'
      const reg = /（(.+?)）/
      const userCode = reg.exec(window?.sessionStorage.getItem('user') || '')?.[1]
      if (tabName && userCode) {
        const auditorCode = auditorNodes.filter(item => item.auditStatus === 2)[0]?.auditorCode || ''
        if (userCode !== auditorCode) {
          return
        }
      }
      commit('commonMutations', { selectData: payload })
      if (payload.auditType === 4) {
        services.getForewarningDetail({ id: payload.sourceIds, view: false }).then(res => {
          if (res?.code === 200) {
            window.localStorage.setItem('isLinking',JSON.stringify(payload))
            getSurveyDetail(res?.data?.surveyId).then(detailRes => {
              let lsArr: { [key: string]: any } = {}
              let optionMap: { [key: string]: any } = {}
              if (detailRes?.code === 200) {
                detailRes?.data?.topics?.forEach(element => {
                  lsArr[element.bizId] = { topicName: element.topicName }
                  if (element.matrixTopics) {
                    for (let i = 0; i < element.matrixTopics.length; i++) {
                      lsArr[element.matrixTopics[i].bizId] = {
                        topicName: element.matrixTopics[i].topicName,
                        parentId: element.matrixTopics[i].parentId,
                      }
                    }
                  }
                  element.topicSetting?.topicOptionSetting?.forEach(item => {
                    optionMap[item.optionId] = item.optionName
                  });
                })
              }
              res.data?.condition?.forEach(element => {
                // element["topicName"] = lsArr[element.target]?.topicName  //不从前端匹配，取后端返回
                if ([3, 9, 14, 18].includes(element.topicType)) {
                  element.target = [lsArr[element.target]?.parentId, element.target]
                } else {
                  element.target = [element.target]
                }
                if (![2, 9].includes(element.topicType)) {
                  element.value = element.value[0]
                  if ([1, 3, 12].includes(element.topicType)) {
                    // element.optionName = optionMap[element.value]  //不从前端匹配，取后端返回
                    element.optionName = element.optionName[0]
                  } else {
                    element.optionName = element.value
                  }
                } else {
                  // element.optionName = element.value?.map(item => optionMap[item])  //不从前端匹配，取后端返回
                }
              })
              commit('lscommit', auditorNodes)
              res.data.payloadId = payload.id
              let lsObj = state.aduitDetailData
              lsObj['detail'] = res?.data
              commit('commonMutations', { aduitDetailData: lsObj })
              commit('commonMutations', { aduitDetailVisible: true, aduitDetailType: payload.auditType })
            })
          } else {
            // Message({
            //   type: 'error',
            //   message:`${res?.msg}`
            // })
          }
        })
      } else if (payload.auditType === 3) {
        services.getFeedbackDetail({ id: payload.sourceIds, view: false }).then(res => {
          if (res?.code === 200) {
            window.localStorage.setItem('isLinking',JSON.stringify(payload))
            res.data.payloadId = payload.id
            commit('lscommit', auditorNodes)
            let lsObj = state.aduitDetailData
            lsObj['detail'] = res?.data
            commit('commonMutations', { aduitDetailData: lsObj })
            commit('commonMutations', { aduitDetailVisible: true, aduitDetailType: payload.auditType })
          } else {
          }
        })
      } else if (payload.auditType === 5) {
        services.getSubscribeDetail({ id: payload.sourceIds, isDraft: 1 }).then(res => {
          if (res?.code === 200) {
            window.localStorage.setItem('isLinking',JSON.stringify(payload))
            res.data.payloadId = payload.id
            commit('lscommit', auditorNodes)
            let lsObj = state.aduitDetailData
            lsObj['detail'] = res?.data
            commit('commonMutations', { aduitDetailData: lsObj })
            commit('commonMutations', { aduitDetailVisible: true, aduitDetailType: payload.auditType })
          } else {
            // Message({
            //   type: 'error',
            //   message:`${res?.msg}`
            // })
          }
        })
      }
    })

  },

  handleAduit({ state, dispatch, commit }, payload) {
    services.doAudit(payload).then(res => {
      if (res?.code === 200) {
        Message({
          type: 'success',
          message: `${i18n.t('contactMonitor.dosuccess')}`
        })
      } else {
        // Message({
        //   type: 'error',
        //   message:`${res?.msg}`
        // })
      }
      dispatch('toAppliedListHandleSearch', state.toAppliedParams)
    })
    //走接口，提交审核 aduitDetailData 清空
    commit('commonMutations', {
      aduitDetailVisible: false,
      aduitDetailType: '',
      aduitDetailData: {
        id: "",
        audit: "同意",
        auditAdvice: "",
        detail: {},
      },
    })
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
